import { dayjs } from 'element-plus';

/** 備貨天數／未來可預約天數設定的訂單方式 key */
export const ORDER_DAYS_KEY = {
  PICK_UP: 'pickup',
  DELIVERY: 'delivery',
  RETAIL_PICK_UP: 'retail_pickup',
  RETAIL_DELIVERY: 'retail_delivery'
};

/**
 * 解析天數設定 JSON 字串，回傳 { [訂單方式 key]: 天數 }
 * 解析失敗、格式不符、非法天數一律忽略，等同該模式未設定。
 */
export function parseOrderDaysConfig(raw) {
  if (raw === null || raw === undefined || raw === '') return {};

  let parsed = raw;
  if (typeof raw === 'string') {
    try {
      parsed = JSON.parse(raw);
    } catch (error) {
      return {};
    }
  }
  if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) return {};

  const config = {};
  for (const [key, value] of Object.entries(parsed)) {
    const days = Number(value);
    if (!Number.isInteger(days) || days < 0) continue;
    config[key] = days;
  }
  return config;
}

/**
 * 依備貨天數與未來可預約天數，算出可選日期區間。
 * @param {number} preparationDays 備貨天數
 * @param {number|null} preOrderDays 未來可預約天數，null 代表不限上限
 * @param {object} [baseDay] 下單日，預設今天（測試可注入）
 */
export function getAvailableDateRange(preparationDays, preOrderDays, baseDay = dayjs()) {
  const preparation = Math.max(Number(preparationDays) || 0, 0);
  const firstAvailableDay = baseDay.add(preparation, 'day');

  if (preOrderDays === null || preOrderDays === undefined) {
    return { firstAvailableDay, lastAvailableDay: null };
  }

  const maxPreOrderDays = Math.max(preOrderDays, 0);
  return {
    firstAvailableDay,
    lastAvailableDay: firstAvailableDay.add(Math.max(maxPreOrderDays - 1, 0), 'day')
  };
}

/** 判斷日期是否落在可選區間之外。 */
export function isOutsideAvailableRange(date, { firstAvailableDay, lastAvailableDay }) {
  const day = dayjs(date);
  if (day.isBefore(firstAvailableDay, 'day')) {
    return true;
  }
  return !!lastAvailableDay && day.isAfter(lastAvailableDay, 'day');
}
